import { handleActions } from "redux-actions";
import actionCreators from "../../actions/ambassadors/ambassadors";

const initialState = {
  list: null,
  prefList: [],
  serviceList: [],
};

export default handleActions(
  {
    [actionCreators.ambassadors.ambassadors.success]: (state, action) =>
      Object.assign({}, state, action.payload.data),
    [actionCreators.ambassadors.ambassadors.failure]: (state, action) =>
      Object.assign({}, state, action.payload.data),
  },
  initialState
);
